import type { TDeferralStatus } from '@/entities/deferral'

/** Badge palette per deferral status — red in force, orange expired, grey lifted. */
export const DEFERRAL_STATUS_PALETTE: Record<TDeferralStatus, string> = {
  ACTIVE: 'red',
  EXPIRED: 'orange',
  LIFTED: 'gray',
}

export const DEFERRAL_STATUSES: TDeferralStatus[] = [
  'ACTIVE',
  'EXPIRED',
  'LIFTED',
]

/** i18n key of a journal `source`; an unknown one falls back to the raw value. */
export const deferralSourceKey = (source: string) =>
  `deferrals.source.${source.toLowerCase()}`
